import React from 'react';
// We gonna use featureFlag directly here to avoid Redux store connecting which
// introduces works on storybook stories which we need to revert anyway
// Will remove this in the flag cleaning up task.
import { ff } from '@atlassian/jira-feature-flagging';
import type { Props } from './types';

import URLs from './urls';

function DocLink({ type: Tag = 'a', href, className, ariaLabel, children, tagRef }: Props) {
	return (
		<Tag
			href={href}
			target="_blank"
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={className}
			{...(ff('jsw.roadmap.close-non-modal-dialogs') && { ref: tagRef })}
			aria-label={ariaLabel}
		>
			{children}
		</Tag>
	);
}

DocLink.URLs = URLs;
export default DocLink;
